import EmptyContentMessage from './empty_content_message';

export default EmptyContentMessage;
